/**
 * @generated SignedSource<<0323b897b6cd4cd4b873e77da36b1d53>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StandaloneSiteThemeStatus = "ACTIVE" | "DISABLED" | "DRAFT" | "PROCESSING" | "VALIDATION_FAILED";
export type StandaloneSiteForkMarketplaceThemeInput = {
  marketplaceThemeID: number;
  standaloneSiteId: string;
};
export type createStandaloneSiteDialogForkThemeMutation$variables = {
  input: StandaloneSiteForkMarketplaceThemeInput;
};
export type createStandaloneSiteDialogForkThemeMutation$data = {
  readonly forkMarketplaceTheme: {
    readonly id: string;
    readonly standaloneSiteThemeID: number;
    readonly status: StandaloneSiteThemeStatus;
  };
};
export type createStandaloneSiteDialogForkThemeMutation = {
  response: createStandaloneSiteDialogForkThemeMutation$data;
  variables: createStandaloneSiteDialogForkThemeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StandaloneSiteThemeInfo",
    "kind": "LinkedField",
    "name": "forkMarketplaceTheme",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "standaloneSiteThemeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createStandaloneSiteDialogForkThemeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createStandaloneSiteDialogForkThemeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "3dc40f9df40b2b17d44618a155eebdfc",
    "id": null,
    "metadata": {},
    "name": "createStandaloneSiteDialogForkThemeMutation",
    "operationKind": "mutation",
    "text": "mutation createStandaloneSiteDialogForkThemeMutation(\n  $input: StandaloneSiteForkMarketplaceThemeInput!\n) {\n  forkMarketplaceTheme(input: $input) {\n    id\n    standaloneSiteThemeID\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "5269b51f43213a6c57bb4a45e54761a2";

export default node;
